import { render, staticRenderFns } from "./PlaceholderNoResults.vue?vue&type=template&id=a7451ba0&"
import script from "./PlaceholderNoResults.vue?vue&type=script&lang=js&"
export * from "./PlaceholderNoResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports